import { UnitSystem } from 'fitify-types/src/types/common'
import { z } from 'fitify-types/src/zod'

type RangeSchemaArgs = {
  minMessage?: string
  maxMessage?: string
}

type Range = [number, number]

export const [AGE_MIN, AGE_MAX] = [18, 120] as const satisfies Range

export const getAgeSchema = ({
  minMessage,
  maxMessage,
}: RangeSchemaArgs = {}) => {
  return z
    .number(minMessage ? { error: minMessage } : undefined)
    .min(AGE_MIN, minMessage ? { error: minMessage } : undefined)
    .max(AGE_MAX, maxMessage ? { error: maxMessage } : undefined)
}

export const [HEIGHT_FEET_MIN, HEIGHT_FEET_MAX] = [
  3, 8,
] as const satisfies Range
export const [HEIGHT_INCH_MIN, HEIGHT_INCH_MAX] = [
  0, 11,
] as const satisfies Range
export const [HEIGHT_IMPERIAL_MIN, HEIGHT_IMPERIAL_MAX] = [
  HEIGHT_FEET_MIN * 12 + HEIGHT_INCH_MIN,
  HEIGHT_FEET_MAX * 12 + HEIGHT_INCH_MAX,
] as const satisfies Range
export const [HEIGHT_METRIC_MIN, HEIGHT_METRIC_MAX] = [
  90, 272,
] as const satisfies Range

export const getHeightSchema = ({ units }: { units?: UnitSystem }) => {
  const isImperial = units === UnitSystem.Imperial
  return z
    .number()
    .min(isImperial ? HEIGHT_IMPERIAL_MIN : HEIGHT_METRIC_MIN)
    .max(isImperial ? HEIGHT_IMPERIAL_MAX : HEIGHT_METRIC_MAX)
}

export const [WEIGHT_IMPERIAL_MIN, WEIGHT_IMPERIAL_MAX] = [
  70, 1000,
] as const satisfies Range
export const [WEIGHT_METRIC_MIN, WEIGHT_METRIC_MAX] = [
  30, 400,
] as const satisfies Range

type GetWeightSchemaArgs = RangeSchemaArgs & {
  units?: UnitSystem
}

export const getWeightSchema = ({
  maxMessage,
  minMessage,
  units,
}: GetWeightSchemaArgs) => {
  const isImperial = units === UnitSystem.Imperial
  return z
    .number(minMessage ? { error: minMessage } : undefined)
    .min(
      isImperial ? WEIGHT_IMPERIAL_MIN : WEIGHT_METRIC_MIN,
      minMessage ? { error: minMessage } : undefined
    )
    .max(
      isImperial ? WEIGHT_IMPERIAL_MAX : WEIGHT_METRIC_MAX,
      maxMessage ? { error: maxMessage } : undefined
    )
}

export const [NAME_CHARS_MIN, NAME_CHARS_MAX] = [2, 17] as const satisfies Range

export const getNameSchema = ({
  minMessage,
  maxMessage,
}: RangeSchemaArgs = {}) => {
  return z
    .string()
    .min(NAME_CHARS_MIN, minMessage ? { error: minMessage } : undefined)
    .max(NAME_CHARS_MAX, maxMessage ? { error: maxMessage } : undefined)
}
